import axios from "axios";
import { saToast } from "../../../template/layout/utility/sa-toast";

export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            consensiGruppiItems: [],
            consensiGruppiRecordNumber: 0,
            consensoGruppo: {},
            consensiGruppiPathResource: "/consensisecuritygruppi",
            filter: {
                consenso: null,
                gruppo: null
            }
        };
    },
    methods: {
        gruppiConsensiLoadData() {
            this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + this.consensiGruppiPathResource;
            this.consensiGruppiItems = [];
            axios.get(link, { params: this.filter })
                .then((response) => {
                    this.consensiGruppiItems = response.data.data.list;
                    this.consensiGruppiRecordNumber = response.data.data.recordNumber;
                    this.closeShowModalLoading();
                })
                .catch((error) => {
                    this.closeShowModalLoading();
                    saToast({ message: error, title: "Attenzione", type: "danger", duration: 5000 })
                });

        },
        salvaAssociazione(associazione, success) {
            let link = process.env.VUE_APP_PATH_API + this.consensiGruppiPathResource;
            axios.post(link, associazione)
                .then((response) => {
                    saToast({ message: "Associazione salvata con successo", title: "Operazione Avvenuta con successo", type: "success", duration: 5000 })
                    success(response);
                    this.closeShowModalLoading();
                })
                .catch((err) => {
                    this.closeShowModalLoading();
                    if (err.response.data) {
                        saToast({ message: err.response.data.messaggio, title: "Attenzione", type: "danger", duration: 5000 })
                    }

                });
        },
        eliminaAssociazione(associazione, success) {
            let link = process.env.VUE_APP_PATH_API + this.consensiGruppiPathResource + "/" + associazione.id;
            axios.delete(link, associazione)
                .then((response) => {
                    saToast({ message: "Associazione Eliminata con successo", title: "Operazione Avvenuta con successo", type: "success", duration: 5000 })
                    success(response);
                    this.closeShowModalLoading();
                })
                .catch((err) => {
                    this.closeShowModalLoading();
                    if (err.response.data) {
                        saToast({ message: err.response.data.messaggio, title: "Attenzione", type: "danger", duration: 5000 })
                    }

                });
        }
    },
};
